import { render, staticRenderFns } from "./WidgetDeviceAlerts.vue?vue&type=template&id=2206143c"
import script from "./WidgetDeviceAlerts.vue?vue&type=script&lang=js"
export * from "./WidgetDeviceAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports